import classNames from "classnames";
import React from "react";

interface props {
  size: "h1" | "h2" | "h1header" | "h2header"
  className?: string,
}

const PanelSegmentHeader = (props: React.PropsWithChildren<props>) => {
  const classes = classNames(props.className,
    {
      "h2-header-container": props.size === "h2",
      "h2-pageheader-container": props.size === "h2header",
      "h1-header-container": props.size === "h1",
      "h1-pageheader-container": props.size === "h1header"
    });

  return <div className={classes}>
    {props.children}
  </div>;
};

export default PanelSegmentHeader;